<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item ref="name" label="未支付订单" name="name">
          <a-row :gutter="10">
            <p class="s_c333 width-120 m-l-5 s_flex_ali">提交订单后</p>
            <a-col :span="6">
              <a-select v-model:value="form.no_pay_time" class="width100" placeholder="请选择">
                <a-select-option :value="15">15分钟</a-select-option>
                <a-select-option :value="30">30分钟</a-select-option>
                <a-select-option :value="60">60分钟</a-select-option>
                <a-select-option :value="1440">24小时</a-select-option>
                <a-select-option :value="4320">72小时</a-select-option>
              </a-select>
            </a-col>
            <a-col :span="12">
              <p class="s_flex_ali">未支付，系统自动取消订单。</p>
            </a-col>
          </a-row>
        </a-form-item>
        <!-- <a-form-item ref="name" label="拼团订单" name="name">
          <a-row :gutter="10">
            <p class="s_c333  width-120 m-l-5">提交订单后</p>
            <a-col :span="6">
              <a-select v-model:value="form.shapring_time" class="width100" placeholder="请选择">
                <a-select-option :value="15">15分钟</a-select-option>
                <a-select-option :value="30">30分钟</a-select-option>
                <a-select-option :value="60">60分钟</a-select-option>
              </a-select>
            </a-col>
            <a-col :span="8">
              <p>未支付，系统自动取消订单。</p>
            </a-col>
          </a-row>
        </a-form-item> -->
        <a-form-item ref="name" label="快递订单" name="name">
          <a-row :gutter="10">
            <p class="s_c333  width-120 m-l-5 s_flex_ali">发货成功后，第</p>
            <a-col :span="6">
              <a-input-number v-model:value="form.deliver_time" style="width:100%" :min='1' :precision='0' placeholder='请输入天数' />
            </a-col>
            <a-col :span="6">
              <p class="s_flex_ali">天系统自动确认收货。</p>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="name" label="自提订单" name="name">
          <a-row :gutter="10">
            <p class="s_c333 width-120 m-l-5 s_flex_ali">付款后，第</p>
            <a-col :span="6">
              <a-input-number v-model:value="form.self_extraction_time" style="width:100%" :min='1' :precision='0' placeholder='请输入天数' />
            </a-col>
            <a-col :span="6">
              <p class="s_flex_ali">天自动核销。</p>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="name" label="渠道订单" name="name">
          <a-row :gutter="10">
            <p class="s_c333 width-120 m-l-5 s_flex_ali">当面交易发货后</p>
            <a-col :span="6">
              <a-input-number v-model:value="form.channel_deliver_day" style="width:100%" :min='1' :precision='0' placeholder='请输入天数' />
            </a-col>
            <a-col :span="6">
              <p style="s_flex_ali">天系统自动确认收货。</p>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="name" label="门店核销订单" name="name">
          <a-row :gutter="10">
            <p class="s_c333 width-120 m-l-5 s_flex_ali">领取礼品后</p>
            <a-col :span="6">
              <a-input-number v-model:value="form.cannot_write_off_time" style="width:100%" :min='1' :max="99" :precision='0' placeholder='请输入天数' />
            </a-col>
            <a-col :span="14">
              <p>天，消费者未到门店进行核销，订单将无法核销。</p>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="name" label="积分商城快递订单" name="name">
          <a-row :gutter="10">
            <p class="s_c333 width-120 m-l-5 s_flex_ali">发货成功后，第</p>
            <a-col :span="6">
              <a-input-number v-model:value="form.point_mall_order_receipt_time" style="width:100%" v-inputFilter:snInt :min='1' :max="99" :precision='0' placeholder='请输入天数' />
            </a-col>
            <a-col :span="14">
              <p>天系统自动确认收货。</p>
            </a-col>
          </a-row>
        </a-form-item>
        <!-- <a-form-item ref="name" label="虚拟类订单" name="name">
          <a-row :gutter="10">
            <a-col :span="13">
              <p class="s_c333 ">前端用户下单时是否提交收货地址</p>
            </a-col>
            <a-col :span="6">
              <a-radio-group v-model:value="form.fictitious_time">
                <a-radio :value="1">
                  是
                </a-radio>
                <a-radio :value="0">
                  否
                </a-radio>
              </a-radio-group>
            </a-col>
          </a-row>
        </a-form-item> -->
        <!-- <a-form-item ref="name" label="短信通知设置" name="name">
              <a-radio-group v-model:value="form.send_message_time" class="width-120">
                <a-radio :value="1">
                  是
                </a-radio>
                <a-radio :value="0">
                  否
                </a-radio>
              </a-radio-group>
              <span class="s_c333 p-l-5">前端用户下单时（云店商城/积分商城实物订单）是否显示短信通知收货人</span>
        </a-form-item> -->
        <a-form-item :wrapper-col="{ span: 8, offset: 3 }">
          <a-button style="width:100px" type="primary" v-has:orderSetupSubmit="onSubmit">
            保存
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-layout>
</template>
<script>
  import { ref, onMounted, reactive, toRefs, inject } from 'vue';
  import { message } from 'ant-design-vue';
  import { getOrderSetup, setOrderSetup } from "@/api/order";
  import { iscode } from "@/utils/app";
  // 初始化默认筛选项数值
  let defForm = {
    no_pay_time: 15,
    // shapring_time: 15,
    deliver_time: 7,
    // receiving_time: '',
    // fictitious_time: '',
    // send_message_time: '',
    cannot_write_off_time:7,
    self_extraction_time:7,
    channel_deliver_day:7,
    point_mall_order_receipt_time:7
  }
  export default {
    name: 'setUp',
    components: {
    },
    setup() {
      const form = ref({ ...defForm });
      const state = reactive({
        labelCol: { span: 3 },
        wrapperCol: { span: 16 }
      });
      const ruleForm = ref()
      const getMore = async () => {
        let res = await getOrderSetup().then(res => res.data);
        if (iscode(res)) {
          var data = res.data.values  ? JSON.parse(res.data.values) : defForm
          form.value = data
        } else {
          message.error(res.msg)
        }
      }
      const onSubmit = () => {
        ruleForm.value.validate().then(async () => {
          const hide = message.loading('正在加载中...', 0);
          let res = await setOrderSetup({ values: JSON.stringify(form.value) }).then(res => res.data);
          if (iscode(res)) {
            setTimeout(hide);
            message.success(res.msg);
          } else {
            setTimeout(hide);
            message.error(res.msg);
          }
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      onMounted(() => {
        getMore();
      });
      return {
        form,
        ...toRefs(state),
        ruleForm,
        onSubmit,
      }
    }
  }
</script>